<template>
    <b-col cols="12" class="content-wrapper filter-form bg-white additional-field p-0 mt-3">
        <b-row>
            <b-col cols="12" md="12">
                <b-col class="form-sample p-3">
                    <b-tabs card align="center">
                        <b-tab :title="`${title} 1`" active class="tab-link p-0 mt-3">
                            <additional-field-view-item @success="alertSuccess($event)" :title="title"
                                @delete-item="deleteType" @cancel="item = false"
                                @error="showError"></additional-field-view-item>
                        </b-tab>
                        <b-tab :title="`${title} 2`" class="tab-link p-0 mt-3">
                            <additional-field-dropdown :title="title" @success="alertSuccess($event)"
                                @delete-item="deleteType" @cancel="item = false"
                                @error="showError"></additional-field-dropdown>
                            <view-item v-if="!!item" :title="`${title} 2`" :item="item" @success="alertSuccess($event)"
                                @delete-item="deleteType" @cancel="item = false" @error="showError"></view-item>

                            <list-items v-else-if="additional_field" :title="title" :items="additionalFields"
                                @show-item="showItem" ref="table">
                                <b-button block v-if="hasPermissionCreate" variant="blue-icon" @click="item = {}"><img
                                        src="@/assets/images/icon/gradient-add.svg">
                                </b-button>
                            </list-items>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'
import AdditionalFieldDropdown from './AdditionalFieldDropdown'
import AdditionalFieldViewItem from './AdditionalFieldViewItem'

export default {
    name: 'additionalFields',
    components: {
        ListItems,
        ViewItem,
        AdditionalFieldDropdown,
        AdditionalFieldViewItem,
    },
    mixins: [
        popupMixins,
        utilityMixins,
        permissionsMixins,
        errorHandlingMixins,
    ],
    data: () => {
        return {
            item: null,
        }
    },
    // mounted() {
    //     this.doSearch()
    // },
    computed: {
        componentName() { return this.$translate('additional_field') },
        title() {
            const { additional_field } = this
            return additional_field
                ? this.$translate('additional_field')
                : this.$translate('customer_additional_field')
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Save'
            }
        },
        additionalFields() {
            const additionalFields =
                (this.$store.state.additionalField.additional_fields &&
                    this.$store.state.additionalField.additional_fields.find(
                        x => x.module_for == 1 && x.type === 2
                    )) ||
                []
            console.log(this.$store.state.additionalField.additional_fields, 'additionalFields');
            return additionalFields.fielditems
        },

        user_permissions() {
            return this.$store.getters.user_permissions
        },
        additional_field() {
            return this.$route.name.slice(0, 10) === 'additional'
        },
    },
    watch: {
        additional_field: {
            immediate:true,
            handler: function () {
                this.doSearch()
            },
            // deep: true,
        },
    },
    methods: {
       async doSearch() {
            let title = this.$route.name.slice(0, 10)
            if (title === 'additional') {
                await this.$store.dispatch('additionalField/fetchAll', {
                    module_for: 1,
                })
            } else {
                await this.$store.dispatch('additionalField/fetchAll', {
                    module_for: 2,
                })
            }
        },

        showItem(id) {
            const item = this.additionalFields.find(x => x.id === id)
            this.item = { ...item }
        },

        alertSuccess(action) {
            this.genericToast(
                this.componentName,
                action,
                'success',
                action.toLowerCase() == 'created' ?
                    `${this.componentName
                    } ${this.$translate('create_alert')}` : `${this.componentName
                    } ${this.$translate('update_alert')}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.genericToast(
                this.componentName,
                'Error!',
                'danger',
                error.message
            )

        },
    },
}
</script>
<style></style>
